import { ChangeEvent, ReactNode, RefObject } from 'react';
import { BriefcaseIcon, UploadOutlineIcon } from '@repo/atomic-components';
import { CHAT_UPLOAD_ACCEPT } from '@/ui/constants/chat';
import { HeaderIconButton } from '@/ui/pages/ChatPage/components/HeaderIconButton';

export const TOOLKIT_TOOLTIP_SHOW_DELAY_MS = 300;

interface ChatInputFileControlsProps {
  fileInputRef: RefObject<HTMLInputElement | null>;
  onFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onUploadFilesClick: () => void;
  /** When set, shows "Add files" (matter chat) instead of "Upload files". */
  onAddMatterFilesClick?: () => void;
  onOpenToolkit: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
  /** Slot between the upload and toolkit buttons (e.g. the link-a-case button). */
  slotAfterUpload?: ReactNode;
}

export const ChatInputFileControls = ({
  fileInputRef,
  onFileChange,
  onUploadFilesClick,
  onAddMatterFilesClick,
  onOpenToolkit,
  isLoading,
  isDisabled,
  slotAfterUpload,
}: ChatInputFileControlsProps) => {
  const isMatterAttachMode = Boolean(onAddMatterFilesClick);
  const uploadTooltip = isMatterAttachMode ? 'Attach files' : 'Upload files';
  const handlePrimaryFilesClick = onAddMatterFilesClick ?? onUploadFilesClick;
  const buttonsDisabled = isDisabled ?? isLoading;

  return (
    <>
      <input ref={fileInputRef} type="file" hidden onChange={onFileChange} accept={CHAT_UPLOAD_ACCEPT} multiple />
      <HeaderIconButton
        icon={<UploadOutlineIcon width={15} height={15} />}
        tooltip={uploadTooltip}
        onClick={handlePrimaryFilesClick}
        disabled={buttonsDisabled}
      />
      {slotAfterUpload}
      <HeaderIconButton
        icon={<BriefcaseIcon width={20} height={20} />}
        tooltip="Browse toolkit"
        tooltipDescription="Choose a ready-made prompt for a common task, or one you've saved."
        tooltipShowDelay={TOOLKIT_TOOLTIP_SHOW_DELAY_MS}
        onClick={onOpenToolkit}
        disabled={buttonsDisabled}
      />
    </>
  );
};
